import { Inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Course } from "../_models/Course";
import { APP_CONFIG } from "../lib/angular/injection-tokens";
import { IAppConfig } from "../lib/config/app-config";
import { CourseCategory } from "../_models/CourseCategory";

@Injectable({
  providedIn: "root",
})
export class CourseService {
  private baseUrl: string = this.config.protectedResourceEndpoint;
  private static readonly path: string = "Course/";
  private static readonly GET_CATEGORIES: string = "getcategories/";

  constructor(private http: HttpClient, @Inject(APP_CONFIG) private config: IAppConfig) { }

  public getCourses$(): Observable<Course[]> {
    return this.http.get<Course[]>(this.baseUrl + CourseService.path);
  }

  public getCourseById$(id): Observable<Course> {
    return this.http.get<Course>(this.baseUrl + CourseService.path + id);
  }

  public getCourseMetadataByIdAndLangId$(id, langId): Observable<Course> {
    return this.http.get<Course>(
      this.baseUrl + CourseService.path + "metadata/" + id + "&" + langId
    );
  }

  public getCoursesByLanguage$(langCode: string): Observable<Course[]> {
    return this.http.get<Course[]>(
      this.baseUrl + CourseService.path + langCode
    );
  }

  public getCategoriesByCourseId$(courseId: number): Observable<CourseCategory[]> {
    return this.http.get<CourseCategory[]>(
      this.baseUrl + CourseService.path + CourseService.GET_CATEGORIES + courseId
    );
  }
}
